module.exports = __webpack_public_path__ + "media/images/DigitalJournal-c856978417377eefc3b1f5db7017c3ab.png";